import type Phaser from "phaser";
import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { meta } from "./meta";
import { ZamanScene } from "./ZamanScene";
import { cardsForLevel } from "./core/generator";

const ZamanMap = levelMapScene({
  id: "zaman",
  gameScene: "zaman",
  title: { tr: "Zaman Çizgisi", en: "Timeline" },
  accent: 0x6a4c93,
  firstTheme: 7,
  track,
  describe: (n, lang) => (lang === "tr" ? `${cardsForLevel(n)} olayı sıraya diz · hatasız 3 yıldız` : `Order ${cardsForLevel(n)} events · no mistakes for 3 stars`),
});

export const game: { meta: typeof meta; scenes: Phaser.Types.Scenes.SceneType[] } = {
  meta,
  scenes: [ZamanMap, ZamanScene],
};
